// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"page-container_pageContainer__23GbT","content":"page-container_content__2bevc"};